import {
  ICravingInfo,
  IDiarySummary,
  ISmokingDiary,
  ISmokingDiaryMonthlyRecord,
} from 'src/@types/apiResponse';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 월별 금연/갈망일지 작성여부 조회 */
export const getSmokingDiaryMonthlyRecord = async (date: string) => {
  try {
    const url = `/smokingDiary/monthly/record/${date}`;

    const response = await instance.get<TApiResponseData<ISmokingDiaryMonthlyRecord[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 일별 금연/갈망일지 요약 조회 */
export const getSmokingDiaryWithCraving = async (date: string) => {
  try {
    const url = `/smokingDiary/withCraving/${date}`;

    const response = await instance.get<TApiResponseData<IDiarySummary>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 금연일지 조회 */
export const getSmokingDiary = async (date: string) => {
  try {
    const url = `/smokingDiary/${date}`;

    const response = await instance.get<TApiResponseData<ISmokingDiary>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 금연일지 작성 */
export const setSmokingDiary = async (quitSmokingData: ISmokingDiary) => {
  try {
    const url = `/smokingDiary`;

    const response = await instance.post<TApiResponseData<any>>(url, quitSmokingData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 일별 갈망 이력/통계 조회 */
export const getUserCravingInfo = async (date: string) => {
  try {
    const url = `/userCraving/info/${date}`;

    const response = await instance.get<TApiResponseData<ICravingInfo>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
